<template>
    <div class="contrast-content-eidt-panel dsp-flex">
        <div class="contrast-content-edit-content">
            <textarea class="layout-cep-textarea" v-bind:class="{'layout-cep-textarea-focus' : focused}" @focus="focusTextArea" @blur="blurTextArea" v-model="textStr" name="base" id="" cols="30" rows="3" placeholder="请输入" maxlength="3000"></textarea>
        </div>
        <div class="contrast-content-edit-button-box">
            <div class="contrast-content-edit-button button-cancel" @click="clickCancel">取消</div>
            <div class="contrast-content-edit-button button-confirm" @click="clickSave">保存</div>
        </div>
    </div>
</template>

<script>
import { UA, UTILS } from '../../modules/utils';
import { COMMENT_DOM, FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'CommentEditPanel',
    props: {
        textValue: {
            type: String,
            default() { return '' }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            clickLock: false,
            textStr: '',
            showFakeText: false,
            curFakeTextNode: null,
            focused: false
        }
    },
    mounted: function() {
        this.textStr = this.textValue;
    },
    methods: {
        focusTextArea() {
            this.focused = true;
        },
        blurTextArea() {
            this.focused = false;
        },
        clickCancel() {
            this.$store.state.contrast.contrastShowCommentEdit = false;
        },
        clickSave() {
            if(this.clickLock) { return; }
            setTimeout(() => { this.clickLock = false }, 300);
            this.clickLock = true;

            this.$store.dispatch('contrast/updateContrast', {
                type: 'content',
                value: this.textStr,
            })
        },
    }
}
</script>